module.exports = __webpack_public_path__ + "2c70b2007ad5933c9543765b2a055f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgtdjzb_g.png
// module id = 816
// module chunks = 3